import { useTranslation } from "react-i18next";
import { Money } from "./Money";
import { Card3D } from "./Card3D";
import { localName } from "../../lib/localName";

// قائمة صفوف داخل بطاقة Card3D: رصيد/مبلغ لكل صف مع رمز العملة.
export const RankList = ({ titleKey, rows, nameField = "name", valueField = "balance", testid, icon }) => {
  const { t, i18n } = useTranslation();
  const ar = i18n.language === "ar";
  const empty = !rows || rows.length === 0;

  return (
    <Card3D titleKey={titleKey} testid={testid} headerRight={icon}>
      {empty ? (
        <p className="py-6 text-center text-xs text-muted-foreground">{t("acct.noData", "—")}</p>
      ) : (
        <div className="grid gap-1.5">
          {rows.slice(0, 8).map((row, i) => (
            <div key={row.id || row.code || i}
                 data-testid={`${testid}-row-${i}`}
                 className="flex items-center justify-between gap-3 rounded-xl bg-background/40 px-3 py-2 text-xs shadow-neu-in">
              <div className="flex min-w-0 items-center gap-2">
                <span className="grid h-6 w-6 place-content-center rounded-full bg-primary/15 font-mono text-[10px] font-black text-primary">
                  {i + 1}
                </span>
                <span className="min-w-0 truncate font-semibold">
                  {localName(row, row[nameField])}
                </span>
              </div>
              <Money value={row[valueField]} currency={row.currency} className="text-xs font-black" />
            </div>
          ))}
        </div>
      )}
    </Card3D>
  );
};
